import React from 'react';
import { observer } from 'mobx-react';
import { Paragraph } from 'components';
import { TableBox, TableContent } from 'libs/connection';
import { FormStore } from 'libs/forms/app';
import { FullFormField } from 'libs/forms';

interface ShippingDetailsFormProps {
  data: {
    refs: any;
    formStore: FormStore;
  };
}

const columns = [
  {
    Header: '',
    accessor: '',
    Cell: function shippingCosts() {
      return <Paragraph>Shipping Costs</Paragraph>;
    },
  },
  {
    Header: 'Shipping Provider',
    accessor: '',
    component: true,
    Cell: observer(function provider({
      data: { refs, formStore },
    }: ShippingDetailsFormProps) {
      return (
        <FullFormField
          fieldStore={formStore.fieldStores.get('provider')}
          refs={refs}
          shouldShowLabel={false}
        />
      );
    }),
  },
  {
    Header: 'Shipping Time',
    accessor: '',
    component: true,
    Cell: observer(function shippingTime({
      data: { refs, formStore },
    }: ShippingDetailsFormProps) {
      return (
        <FullFormField
          fieldStore={formStore.fieldStores.get('deliveryTime')}
          refs={refs}
        />
      );
    }),
  },
  {
    Header: 'Cost',
    accessor: '',
    component: true,
    Cell: observer(function cost({
      data: { refs, formStore },
    }: ShippingDetailsFormProps) {
      return (
        <FullFormField
          fieldStore={formStore.fieldStores.get('cost')}
          refs={refs}
        />
      );
    }),
  },
  {
    Header: 'Discount',
    accessor: '',
    component: true,
    Cell: observer(function discount({
      data: { refs, formStore },
    }: ShippingDetailsFormProps) {
      return (
        <FullFormField
          fieldStore={formStore.fieldStores.get('discount')}
          refs={refs}
        />
      );
    }),
  },
  {
    Header: 'Amount',
    accessor: '',
    component: true,
    Cell: observer(function amount({
      data: { formStore },
    }: ShippingDetailsFormProps) {
      const shippingQuoteApp = formStore.target;
      let calculatedAmount = '--';
      if (!Number.isNaN(shippingQuoteApp.fmtAmount)) {
        calculatedAmount = shippingQuoteApp.fmtAmount;
      }
      return <Paragraph>{calculatedAmount}</Paragraph>;
    }),
  },
];

export const ShippingDetailsForm = observer(
  ({ formStore }: { formStore: FormStore }) => {
    const refs = {};
    return (
      <TableBox
        wrapperStyle={{
          mx: null,
        }}
      >
        <TableContent
          nodes={[{ formStore, refs }]}
          columns={columns}
          loading={false}
          showEmptyPlaceholder={false}
          emptyTablePlaceholder={null}
          RowActionButtons={null}
          loadingRowCount={5}
        />
      </TableBox>
    );
  },
);
